import React from "react";
import FiscalFundingSummary from "../../../finance/FiscalFundingSummary";
import { ActionPlanField, ActionPlanOccupation, ActionPlanSection, formatPlanDate } from "./ActionPlanModalLayout";

const present = value => value === null || value === undefined || value === "" ? "Not recorded" : value;
const stamp = value => {
  if (!value) return "Not recorded";
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(value))) return formatPlanDate(value);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString("en-CA", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
};

export default function ActionPlanDetailsView({ form, plan, metadata, labels, searchNocCodes }) {
  const hasOutcome = plan.status === "closed" || form.resultCode || form.resultDate || form.outcomeSummary || form.closureNotes;
  return <>
    <ActionPlanSection title="Plan summary"><p className={`action-plan-summary${form.summary ? "" : " action-plan-muted"}`}>{form.summary || "No summary recorded."}</p></ActionPlanSection>
    {hasOutcome && <ActionPlanSection title="Outcome">
      <dl className="action-plan-values">
        <ActionPlanField label="Result" hint={form.resultCode ? `Code ${form.resultCode}` : null}>{present(labels.result)}</ActionPlanField>
        <ActionPlanField label="Result date">{formatPlanDate(form.resultDate)}</ActionPlanField>
        <ActionPlanField label="Result education level">{present(labels.resultEducation)}</ActionPlanField>
        {form.resultCode === "4" && <ActionPlanField label="Future education level">{present(labels.futureEducation)}</ActionPlanField>}
        {form.resultCode === "2" && <ActionPlanField label="Occupation at plan outcome"><ActionPlanOccupation code={form.resultNoc} version={form.resultNocVersion} searchNocCodes={searchNocCodes} /></ActionPlanField>}
        {form.outcomeSummary && <ActionPlanField label="Outcome summary" wide><span className="action-plan-summary">{form.outcomeSummary}</span></ActionPlanField>}
        {form.closureNotes && <ActionPlanField label="Closure notes" wide><span className="action-plan-summary">{form.closureNotes}</span></ActionPlanField>}
      </dl>
    </ActionPlanSection>}
    <details className="action-plan-view-disclosure">
      <summary>Additional details <span>Funding and record history</span></summary>
      <div className="action-plan-view-disclosure-content">
        <div><h3>Funding allocation</h3><dl className="action-plan-values">
          <ActionPlanField label="Budget pot">{present(labels.budgetPot)}<FiscalFundingSummary interventions={plan.interventions || []} /></ActionPlanField>
          <ActionPlanField label="Paid from">{labels.postingContext}</ActionPlanField>
        </dl></div>
        <div className="action-plan-record-history"><h3>Record history</h3><dl className="action-plan-values">
          <ActionPlanField label="Assigned to" hint={metadata.ownerEmail && metadata.ownerEmail !== metadata.owner ? metadata.ownerEmail : null}>{metadata.owner}</ActionPlanField>
          <ActionPlanField label="Created at">{stamp(metadata.createdAt)}</ActionPlanField>
          <ActionPlanField label="Last updated">{stamp(metadata.updatedAt)}</ActionPlanField>
          <ActionPlanField label="Activated at">{stamp(metadata.activatedAt)}</ActionPlanField>
          <ActionPlanField label="Closed at">{stamp(metadata.closedAt)}</ActionPlanField>
          <ActionPlanField label="Archived at">{stamp(metadata.archivedAt)}</ActionPlanField>
        </dl></div>
      </div>
    </details>
    <details className="action-plan-view-disclosure">
      <summary>Participant at plan start <span>ILMP reporting details</span></summary>
      <div className="action-plan-view-disclosure-content"><dl className="action-plan-values">
        <ActionPlanField label="Employment status at plan start">{present(labels.employment)}</ActionPlanField>
        <ActionPlanField label="EI claimant status">{present(labels.eiClaimant)}</ActionPlanField>
        <ActionPlanField label="Education level">{present(labels.education)}</ActionPlanField>
        {form.educationLevel && form.educationLevel !== "1" && <ActionPlanField label="Education province / territory">{present(labels.educationProvince)}</ActionPlanField>}
        <ActionPlanField label="Social Assistance Recipient">{present(labels.socialAssistance)}</ActionPlanField>
        <ActionPlanField label="Childcare need">{present(labels.childcareNeed)}</ActionPlanField>
        {form.childcareNeed === "1" && <ActionPlanField label="Childcare funding">{present(labels.childcareFunding)}</ActionPlanField>}
        {form.prevEmployment === "2" && <>
          <ActionPlanField label="Previous employment schedule">{present(labels.schedule)}</ActionPlanField>
          <ActionPlanField label="Occupation at plan start"><ActionPlanOccupation code={form.prevEmploymentNoc} version={form.prevEmploymentNocVersion} searchNocCodes={searchNocCodes} /></ActionPlanField>
        </>}
        <ActionPlanField label="Barriers to employment" wide>{labels.barriers || "Not recorded"}</ActionPlanField>
      </dl></div>
    </details>
  </>;
}
